// extracted by mini-css-extract-plugin
module.exports = {"waiting":"styles_waiting__ax_jN"};